/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { createContext, HTMLAttributes, useContext } from 'react'
import { UsePaginationHook } from '../../hooks/usePagination'

type PaginationProviderProps = {
  context: UsePaginationHook
}

export const PaginationContext = createContext<UsePaginationHook>({
  hasNext: false,
  hasPrevious: false,
  limit: 0,
  nextPage: 0,
  offset: 0,
  page: 0,
  previousPage: 0,
  totalElements: 0,
  totalPages: 0,
  change: function (_page: number, _limit: number): void {
    throw new Error('Function not implemented.')
  },
  first: function (): void {
    throw new Error('Function not implemented.')
  },
  last: function (): void {
    throw new Error('Function not implemented.')
  },
  next: function (): void {
    throw new Error('Function not implemented.')
  },
  previous: function (): void {
    throw new Error('Function not implemented.')
  },
  setLimit: function (_limit: number): void {
    throw new Error('Function not implemented.')
  },
  setPage: function (_page: number): void {
    throw new Error('Function not implemented.')
  }
})

export function usePaginationContext (): UsePaginationHook {
  return useContext(PaginationContext)
}

function PaginationProvider (props: PaginationProviderProps & HTMLAttributes<any>) {
  const { children, context } = props
  return (
    <PaginationContext.Provider value={context}>
      {children}
    </PaginationContext.Provider>
  )
}

export default PaginationProvider
